export default "__VITE_ASSET__DwpF0BrT__"